import './config/amplifyConfig';  // Amplify must initialize before anything else
import React from 'react';
import {createRoot} from "react-dom/client";
import './styles/tokens.css';
import './styles/global.css';
import "@fontsource/mulish";
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { PortalVersionProvider } from './contexts/PortalVersionContext.jsx';
import App from './App.jsx';
import { initSession } from './services/session';

// Decrypt the persisted session into memory before the first render, so the
// synchronous getSession() the app relies on for routing has data available.
// initSession never rejects (it clears the session on any failure).
initSession().finally(() => {
    const root = createRoot(document.getElementById("root"))
    root.render(
        <PortalVersionProvider>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </PortalVersionProvider>
    )
})
